import { Injectable } from '@angular/core';
import {Campaign} from './campaign.interface';

@Injectable({ providedIn: 'root' })
export class CampaingsStateService {
  private _campaign: Campaign | null = null;

  setCampaign(campaign: Campaign): void {
    this._campaign = campaign;
  }

  getCampaign(): Campaign | null {
    return this._campaign;
  }

  clearCampaign(): void {
    this._campaign = null;
  }
}
